export function lockIndustryModule(modules, lock = false) {
    if (!lock) return modules
    return modules.map((res, index) => {
        return {
            ...res,
            lock: index != 0,
        }
    })
}

export function lockUniversalModule(modules, lock = false) {
    if (!lock) return modules

    let notLockModuleIdList = ['1', '3', '9']

    let modulesList = modules.map((res, index) => {
        let lockTaggle = notLockModuleIdList.indexOf(res.moduleId)

        if (lockTaggle != -1) {
            notLockModuleIdList.splice(lockTaggle, 1)
        }

        return {
            ...res,
            lock: lockTaggle == -1,
        }
    })

    let taggle = 0
    return modulesList.map((res, index) => {
        if (res.lock && taggle < notLockModuleIdList.length) {
            res.lock = false
            taggle++
        }
        return res
    })
}
